"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var page_header_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/designated/page_header"));
var PageHeaderStore = /** @class */ (function () {
    function PageHeaderStore() {
        this.component = page_header_1.default;
        this.title = '無料査定依頼';
    }
    return PageHeaderStore;
}());
exports.default = PageHeaderStore;
